function fromObject(object) {
  const entries = Object.entries(object)
  if (typeof URLSearchParams == 'function') {
    const p = new URLSearchParams()
    entries.forEach(([key, value]) => {
      p.set(key, String(value))
    })
    return p.toString()
  }

  return entries
    .map(([key, value]) => encodeURIComponent(key) + '=' + encodeURIComponent(value))
    .join('&')
}

function toObject(string) {
  if (typeof URLSearchParams == 'function') {
    const p = new URLSearchParams(string)
    const params = []
    p.forEach((value, key) => params.push([key, value]))

    return params.reduce((acc, [key, value]) => {
      acc[key] = value
      return acc
    }, {})
  }

  return getQueryString(string)
}

function getQueryString(queryString) {
  const result = {},
    re = /([^&=]+)=([^&]*)/g
  let m

  if (queryString[0] === '?') {
    queryString = queryString.slice(1)
  }

  while ((m = re.exec(queryString))) {
    result[decodeURIComponent(m[1])] = decodeURIComponent(m[2])
  }

  return result
}

export default {
  fromObject,
  toObject,
}
